module.exports = __webpack_public_path__ + "img/hr-garballo-12.d5654efc.png";